module.exports = __webpack_public_path__ + "img/kate_macK210991.d7be3bd6.jpg";